import React, { createContext, useContext, useState, useEffect } from 'react';

interface DeveloperContextType {
  isDeveloperMode: boolean;
  setIsDeveloperMode: (mode: boolean) => void;
  toggleDeveloperMode: () => void;
}

const DeveloperContext = createContext<DeveloperContextType | undefined>(undefined);

export const useDeveloper = () => {
  const context = useContext(DeveloperContext);
  if (context === undefined) {
    throw new Error('useDeveloper must be used within a DeveloperProvider');
  }
  return context;
};

interface DeveloperProviderProps {
  children: React.ReactNode;
}

export const DeveloperProvider: React.FC<DeveloperProviderProps> = ({ children }) => {
  const [isDeveloperMode, setIsDeveloperMode] = useState(false);

  // Check for developer mode in localStorage on mount
  useEffect(() => {
    const savedMode = localStorage.getItem('developerMode');
    if (savedMode === 'true') {
      setIsDeveloperMode(true);
    }
  }, []);

  // Save developer mode state to localStorage
  useEffect(() => {
    localStorage.setItem('developerMode', isDeveloperMode.toString());
  }, [isDeveloperMode]);

  const toggleDeveloperMode = () => {
    setIsDeveloperMode(prev => !prev);
  };

  return (
    <DeveloperContext.Provider value={{
      isDeveloperMode,
      setIsDeveloperMode,
      toggleDeveloperMode
    }}>
      {children}
    </DeveloperContext.Provider>
  );
}; 